export default "__VITE_ASSET__DIK6QiY4__"